import Vue from 'vue'
import { mapGetters,mapActions } from 'vuex';
import axios from 'axios';
import XLSX from 'xlsx'
import {
  getContextoSemanaAnterior,
  buildComparativasPayload,
  buildTeachersConDetalle,
  buildRolSnapshotSabatino,
} from '@/utils/nominaTeachersHistorial'

export default {
	data: () => ({
		gruposSnapshotSabAnterior: [],
  }),

  created(){


  },

  watch: {

  	
  },

  computed:{

  	totalHoras(){
  		return this.gruposActivos.filter( el => { return el.deleted == 0 && el.sabado }).map(item => item.horas_semana ).reduce((prev, curr) => prev + curr, 0)
  	},

  	notasSabatino ( ){
			const filas = this.filasHorasGruposSab || []
			if (!filas.length) {
				if (this.gruposSnapshotSabAnterior && this.gruposSnapshotSabAnterior.length) return ''
				return this.notasSabatinoHistorial || ''
			}
			const lineas = filas.map((f) => this.formatoHorasCambio(f.diferencia) + ' h  ' + f.grupo)
			return '\nHoras por grupo:\n' + lineas.join('\n') + '\nTotal: ' + this.formatoHorasCambio(this.totalHorasGruposSab) + ' h'
		},

		filasHorasGruposSab() {
			return this.armarFilasHorasGruposSab()
		},

		totalHorasGruposSab() {
			return (this.filasHorasGruposSab || []).reduce((suma, fila) => suma + fila.diferencia, 0)
		},

		totalHorasAnteriorSab() {
			return (this.filasHorasGruposSab || []).reduce((suma, fila) => suma + fila.horas_anterior, 0)
		},

		totalHorasActualSab() {
			return (this.filasHorasGruposSab || []).reduce((suma, fila) => suma + fila.horas_actual, 0)
		},

		diferenciaHorasNominaSab() {
			return (Number(this.horasImpartidas) || 0) - (Number(this.horasImpartidasAnt) || 0)
		},

		headersHorasGruposSab() {
			const semanaAct = Number(this.selectedHeaders) || 0
			const semanaAnt = semanaAct === 1 ? 4 : semanaAct - 1
			return [
				{ text: 'Grupo', value: 'grupo' },
				{ text: 'Horas sem. ' + semanaAnt, value: 'horas_anterior', align: 'end', width: '140px' },
				{ text: 'Horas sem. ' + semanaAct, value: 'horas_actual', align: 'end', width: '130px' },
				{ text: 'Cambió', value: 'diferencia', align: 'end', width: '110px' },
			]
		}

  },

	methods: {

		formatoHorasCambio(valor) {
			const n = Number(valor) || 0
			return (n > 0 ? '+' : '') + n
		},

		claseFilaHorasGrupo(item) {
			if (!item || !item.diferencia) return ''
			return item.diferencia > 0 ? 'green lighten-5' : 'red lighten-5'
		},

		claveGrupoSab(grupo) {
			if (!grupo) return ''
			const id = Number(grupo.id_grupo || grupo.iderp)
			if (Number.isFinite(id) && id > 0) return 'id:' + id
			return 'n:' + String(grupo.grupo || '')
		},

		contarHorasBloquesSab(grupo, semana) {
			if (!grupo) return 0
			const nombre = String(grupo.grupo || '')
			const teens = nombre.indexOf('TEENS') !== -1
			const dias = teens ? ['lu', 'ma', 'mi'] : ['lu', 'ma', 'mi', 'ju', 'vi']
			// La copia guardada trae lu/ma/mi. El rol en vivo trae lu2, lu3, etc.
			const conSemana = dias.some((d) => grupo[d + semana] !== undefined)
			let horas = 0
			for (let i = 0; i < dias.length; i++) {
				const clave = conSemana ? dias[i] + semana : dias[i]
				if (this.esTeacherAsignado(grupo[clave])) horas++
			}
			return horas
		},

		/** Grupos cuya cantidad de bloques con teacher cambió entre las dos semanas. */
		armarFilasHorasGruposSab() {
			const semanaAct = Number(this.selectedHeaders)
			if (!semanaAct) return []

			const semanaAnt = semanaAct === 1 ? 4 : semanaAct - 1
			const actuales = this.gruposActivos || []
			const snapshot = this.gruposSnapshotSabAnterior || []
			const filas = []

			const push = (grupo, anterior, actual, extra) => {
				if (anterior === actual) return
				filas.push({
					clave: String(extra || grupo || 'g') + '-' + filas.length,
					grupo: grupo,
					horas_anterior: anterior,
					horas_actual: actual,
					diferencia: actual - anterior,
				})
			}

			const cruzar = (listaAnt, semanaDeAnt) => {
				const mapAnt = {}
				;(listaAnt || []).forEach((g) => {
					const clave = this.claveGrupoSab(g)
					if (clave && !mapAnt[clave]) mapAnt[clave] = g
				})
				const vistos = {}
				actuales.forEach((g) => {
					if (!g || !g.grupo) return
					const clave = this.claveGrupoSab(g)
					vistos[clave] = true
					push(
						g.grupo,
						this.contarHorasBloquesSab(mapAnt[clave], semanaDeAnt),
						this.contarHorasBloquesSab(g, semanaAct),
						clave
					)
				})
				Object.keys(mapAnt).forEach((clave) => {
					if (vistos[clave]) return
					const gAnt = mapAnt[clave]
					push(gAnt.grupo, this.contarHorasBloquesSab(gAnt, semanaDeAnt), 0, clave)
				})
			}

			if (snapshot.length) {
				cruzar(snapshot, semanaAnt)
			} else if (semanaAct === 1) {
				cruzar(this.gruposRoles2, 4)
			} else {
				actuales.forEach((g) => {
					if (!g || !g.grupo) return
					push(
						g.grupo,
						this.contarHorasBloquesSab(g, semanaAnt),
						this.contarHorasBloquesSab(g, semanaAct),
						g.id_grupo || g.iderp
					)
				})
			}

			filas.sort((a, b) => {
				const porTamano = Math.abs(b.diferencia) - Math.abs(a.diferencia)
				if (porTamano !== 0) return porTamano
				if (b.diferencia !== a.diferencia) return b.diferencia - a.diferencia
				return String(a.grupo).localeCompare(String(b.grupo), 'es')
			})
			return filas
		},

		/** true si el bloque tiene teacher real (no vacío / SIN TEACHER / 1202 / -1) */
		esTeacherAsignado(idTeacher) {
			if (idTeacher === null || idTeacher === undefined || idTeacher === '') return false
			const n = Number(idTeacher)
			if (Number.isNaN(n)) return false
			// -1 = Sin Teacher explícito en BD (truthy en JS, no usar !id)
			return n > 0 && n !== 1202
		},

		/**
		 * Cambios de grupos sabatinos entre semana anterior y actual.
		 * Revisa lu/ma/mi/ju/vi (bloques del sábado).
		 */
		calcularNotasSabatino() {
			const semanaAct = this.selectedHeaders
			if (!semanaAct) return ''

			const dias = ['lu', 'ma', 'mi', 'ju', 'vi']
			const nuevos = []
			const cambios = []
			const sinTeacher = []

			const pushUnique = (arr, nombre) => {
				if (nombre && !arr.includes(nombre)) arr.push(nombre)
			}

			const revisarGrupo = (nombre, getAnt, getAct) => {
				let gano = false
				let perdio = false
				let cambio = false

				for (const d of dias) {
					const ant = getAnt(d)
					const act = getAct(d)
					const habia = this.esTeacherAsignado(ant)
					const hay = this.esTeacherAsignado(act)

					if (!habia && hay) gano = true
					else if (habia && !hay) perdio = true
					else if (habia && hay && Number(ant) !== Number(act)) cambio = true
				}

				if (gano) pushUnique(nuevos, nombre)
				else if (cambio) pushUnique(cambios, nombre)
				else if (perdio) pushUnique(sinTeacher, nombre)
			}

			const snapshot = this.gruposSnapshotSabAnterior || []

			// Semana pagada: la anterior sale de nomina_rol_snapshot, no del rol que sigue editable.
			if (snapshot.length) {
				const semanaAnt = semanaAct === 1 ? 4 : semanaAct - 1
				const gruposAct = this.gruposActivos || []
				const mapAnt = {}
				snapshot.forEach((g) => {
					if (g && g.grupo) mapAnt[g.grupo] = g
				})
				const vistos = {}

				gruposAct.forEach((gAct) => {
					if (!gAct || !gAct.grupo) return
					vistos[gAct.grupo] = true
					const gAnt = mapAnt[gAct.grupo]
					revisarGrupo(
						gAct.grupo,
						(d) => (gAnt ? gAnt[`${d}${semanaAnt}`] : null),
						(d) => gAct[`${d}${semanaAct}`]
					)
				})

				Object.keys(mapAnt).forEach((nombre) => {
					if (vistos[nombre]) return
					const gAnt = mapAnt[nombre]
					revisarGrupo(
						nombre,
						(d) => gAnt[`${d}${semanaAnt}`],
						() => null
					)
				})
			} else if (semanaAct === 1) {
				// Sin copia guardada: ciclo anterior (sem 4 en gruposRoles2) vs actual (sem 1)
				const gruposAnt = this.gruposRoles2 || []
				const gruposAct = this.gruposActivos || []
				const mapAnt = {}
				gruposAnt.forEach((g) => {
					if (g && g.grupo) mapAnt[g.grupo] = g
				})

				gruposAct.forEach((gAct) => {
					if (!gAct || !gAct.grupo) return
					const gAnt = mapAnt[gAct.grupo]
					revisarGrupo(
						gAct.grupo,
						(d) => (gAnt ? gAnt[`${d}4`] : null),
						(d) => gAct[`${d}1`]
					)
				})
			} else {
				const semanaAnt = semanaAct - 1
				const grupos = this.gruposActivos || []

				grupos.forEach((g) => {
					if (!g || !g.grupo) return
					revisarGrupo(
						g.grupo,
						(d) => g[`${d}${semanaAnt}`],
						(d) => g[`${d}${semanaAct}`]
					)
				})
			}

			const partes = []
			if (nuevos.length) {
				partes.push(`Grupos con teacher nuevo:\n${nuevos.map((n) => ` ${n}`).join('\n')}`)
			}
			if (cambios.length) {
				partes.push(`Grupos con cambio de teacher:\n${cambios.map((n) => ` ${n}`).join('\n')}`)
			}
			if (sinTeacher.length) {
				partes.push(`Grupos que quedaron sin teacher:\n${sinTeacher.map((n) => ` ${n}`).join('\n')}`)
			}

			if (!partes.length) return ''
			return `\n${partes.join('\n\n')}`
		},

		calcPorcentajeAceptacion(teachers, campoEstatus, filtroPago) {
			let elegibles = (teachers || []).filter((el) =>
				Number(el.id_teacher) < 100000 &&
				el.teacher !== 'TOTAL' &&
				el.teacher !== 'SIN TEACHER'
			)

			if (typeof filtroPago === 'function') {
				elegibles = elegibles.filter(filtroPago)
			}

			if (!elegibles.length) return '0.00'

			const aceptados = elegibles.filter((el) => Number(el[campoEstatus]) === 1).length
			return ((aceptados / elegibles.length) * 100).toFixed(2)
		},

		inciarNominaSabtina( ){

			this.tabla1Comparativa = []
      this.tabla2Comparativa = []
      this.tabla1ComparativaQ = []
      this.tabla2ComparativaQ = []
      this.bonosAnterioresHistorial = []
      this.bonosHistorialActual = []
      this.gruposCicloActual = []
      this.mapaConsecutivos = {}

      this.categorias1 =[]
      this.categorias2 =[]
      this.categorias1Q =[]
      this.categorias2Q =[]

      this.costoHora1 = 0
      this.costoHora2 = 0
      this.usandoHistorialSab = false
      this.sinHistorialComparativaSab = false
      this.sinHistorialComparativaQuin = false
      this.notasSabatinoHistorial = ''
      this.gruposSnapshotSabAnterior = []

    	if( !this.ciclo ){
    		return this.validarErrorDirecto('Selecciona un ciclo por favor')
    	}
    	this.gruposRoles = []
    	this.cargar      = true

      const peticiones = [
        this.$http.post('rol.clases', this.ciclo),
        this.$http.post('rol.clases.nomina2', this.ciclo),
      ]
      if ( this.selectedHeaders == 1 ) {
        peticiones.push( this.$http.post('rol.clases.bonos', this.ciclo ) )
      }

      return Promise.all( peticiones ).then( async ( respuestas ) => {
        const response = respuestas[0]
        const resAnterior = respuestas[1]
        const resBonos = respuestas[2]

      	// Filtramos los grupos activos y que son solo sabatino
        this.gruposActivos    = response.data.respuesta.filter( el => { return el.deleted == 0 && el.sabado })
        // Inventario del ciclo seleccionado (INBI/FAST) — no se sobreescribe con el ciclo anterior
        this.gruposCicloActual = response.data.respuesta.filter( el => { return el.deleted == 0 && !el.sabado })

        this.horasDoblesSabatino = response.data.horasDoblesSabatino
        console.log( 'Dobles sabatino',this.horasDoblesSabatino )

        // Filtramos los rebajes
        this.rebajes          = response.data.rebajes 

        this.sabatinoSem      = response.data.sabatinoSem[`sem${this.selectedHeaders}`]
        this.sabatinoSemT     = response.data.sabatinoSemT[`sem${this.selectedHeaders}`]

        // Veremos el this.selectedHeaders == 3 si es 3, la quincena es 2, semana 1 y 2 del ciclo actual
        if( this.selectedHeaders == 3 ){

        	this.gruposQuincena   = response.data.respuesta.filter( el => { return el.deleted == 0 && !el.sabado })
        	this.horasDobles      = response.data.horasDobles
        	
        	// GUARDAMOS LAS HORAS DE LA SEMANA 1 y 2
	        this.dominicalSem  = response.data.dominicalSem[`sem1`]
	        this.dominicalSem  += response.data.dominicalSem[`sem2`]

	        this.lvSem  = response.data.lvSem[`sem1`]
	        this.lvSem  += response.data.lvSem[`sem2`]

	        this.lvSemT  = response.data.lvSemT[`sem1`]
	        this.dominicalSemT  = response.data.dominicalSemT[`sem1`]

        }

        this.pagos            = response.data.teachers

        const estatusCicloActual = response.data.estatusNominaQuincena || []
        this.aplicarNominaAnterior( resAnterior.data )
        this.comentariosT = estatusCicloActual
        if ( resBonos ) {
          this.aplicarBonosTeachers( resBonos.data )
        }

        this.limpiarGrupos( )

        this.sacarTeachers( )

        this.sacarHorasSabado1( )
  	
	    	this.sacarTotales( )
	    	
	    	this.getTablaComparativa( )

	    	this.getTablaComparativaAnt( )

	    	// Solo si es semana 1 o 3, se inicia también la quincena
	    	if( [1,3].includes( this.selectedHeaders )){
	    		this.iniciarQuincena( )
	    	}

        this.sinHistorialComparativaQuin = false

        return this.aplicarHistorialSabAnterior( ).then(() => {
          this.igualarCategorias( )
          this.motivoDiferencias( )
          this.formatMoney( )
        })

        // this.cargar      = false
      }).catch( error =>{
      	console.log( error )
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
		},

		aplicarNominaAnterior( data ){
			this.gruposRoles2 = []
			this.gruposRoles2 = data.respuesta.filter( el => { return el.deleted == 0 && el.sabado })

			if( this.selectedHeaders == 1 ){
				this.gruposQuincena   = data.respuesta.filter( el => { return el.deleted == 0 && !el.sabado })
				this.horasDobles      = data.horasDobles
				this.dominicalSem  = data.dominicalSem[`sem3`]
				this.dominicalSem  += data.dominicalSem[`sem4`]

				this.lvSem  = data.lvSem[`sem3`]
				this.lvSem  += data.lvSem[`sem4`]

				this.lvSemT  = data.lvSemT[`sem3`]
				this.dominicalSemT  = data.dominicalSemT[`sem3`]
			}

			this.gruposQuincenaAnt = data.respuesta.filter( el => { return el.deleted == 0 && !el.sabado })
			this.cicloAnt          = data.id_ciclo
			// id_siguiente (ciclo actual) → id_anterior (ciclo previo)
			this.mapaConsecutivos   = data.mapaConsecutivos || {}
		},

		aplicarBonosTeachers( data ){
			this.bonosTeachers = Array.isArray(data) ? data : ((data && data.teachers) ? data.teachers : [])
			console.log( this.bonosTeachers )
		},


    exportar( ){
      this.exportExcel( this.prospectosCerrados  , 'prospectosCerrados')
    },

    limpiarGrupos ( ) {
    	for( const i in this.gruposActivos ){
    		const { grupo } = this.gruposActivos[i]
      	if( ( grupo.match('SABATI') && grupo.match('TEENS') ) || ( grupo.match('DOMINICAL') && grupo.match('TEENS') ) ){
    			this.gruposActivos[i].ju1_n = null
    			this.gruposActivos[i].ju1   = null
    			this.gruposActivos[i].vi1_n = null
    			this.gruposActivos[i].vi1   = null
    			this.gruposActivos[i].ju2_n = null
    			this.gruposActivos[i].ju2   = null
    			this.gruposActivos[i].vi2_n = null
    			this.gruposActivos[i].vi2   = null
    			this.gruposActivos[i].ju3_n = null
    			this.gruposActivos[i].ju3   = null
    			this.gruposActivos[i].vi3_n = null
    			this.gruposActivos[i].vi3   = null
    			this.gruposActivos[i].ju4_n = null
    			this.gruposActivos[i].ju4   = null
    			this.gruposActivos[i].vi4_n = null
    			this.gruposActivos[i].vi4   = null
    			this.gruposActivos[i].ju5_n = null
    			this.gruposActivos[i].ju5   = null
    			this.gruposActivos[i].vi5_n = null
    			this.gruposActivos[i].vi5   = null
    		}      		
    	}
    },

    limpiarGruposAnt ( ) {
    	for( const i in this.gruposRoles2 ){
    		const { grupo } = this.gruposRoles2[i]
      	if( ( grupo.match('SABATI') && grupo.match('TEENS') ) || ( grupo.match('DOMINICAL') && grupo.match('TEENS') ) ){
    			this.gruposRoles2[i].ju1_n = null
    			this.gruposRoles2[i].ju1   = null
    			this.gruposRoles2[i].vi1_n = null
    			this.gruposRoles2[i].vi1   = null
    			this.gruposRoles2[i].ju2_n = null
    			this.gruposRoles2[i].ju2   = null
    			this.gruposRoles2[i].vi2_n = null
    			this.gruposRoles2[i].vi2   = null
    			this.gruposRoles2[i].ju3_n = null
    			this.gruposRoles2[i].ju3   = null
    			this.gruposRoles2[i].vi3_n = null
    			this.gruposRoles2[i].vi3   = null
    			this.gruposRoles2[i].ju4_n = null
    			this.gruposRoles2[i].ju4   = null
    			this.gruposRoles2[i].vi4_n = null
    			this.gruposRoles2[i].vi4   = null
    			this.gruposRoles2[i].ju5_n = null
    			this.gruposRoles2[i].ju5   = null
    			this.gruposRoles2[i].vi5_n = null
    			this.gruposRoles2[i].vi5   = null
    		}      		
    	}
    },

    sacarTeachers ( ) {
    	// Sacar a los teachers que dan clase
    	// Vamos a sacar los teachers de cada bloque
      let tlu1 = this.gruposActivos.filter( el => { return el[`lu${this.selectedHeaders}_n`] }).map((registro) => { return { id_teacher: registro[`lu${this.selectedHeaders}`], teacher: registro[`lu${this.selectedHeaders}_n`]}})
      let tma1 = this.gruposActivos.filter( el => { return el[`ma${this.selectedHeaders}_n`] }).map((registro) => { return { id_teacher: registro[`ma${this.selectedHeaders}`], teacher: registro[`ma${this.selectedHeaders}_n`]}})
      let tmi1 = this.gruposActivos.filter( el => { return el[`mi${this.selectedHeaders}_n`] }).map((registro) => { return { id_teacher: registro[`mi${this.selectedHeaders}`], teacher: registro[`mi${this.selectedHeaders}_n`]}})
      let tju1 = this.gruposActivos.filter( el => { return el[`ju${this.selectedHeaders}_n`] }).map((registro) => { return { id_teacher: registro[`ju${this.selectedHeaders}`], teacher: registro[`ju${this.selectedHeaders}_n`]}})
      let tvi1 = this.gruposActivos.filter( el => { return el[`vi${this.selectedHeaders}_n`] }).map((registro) => { return { id_teacher: registro[`vi${this.selectedHeaders}`], teacher: registro[`vi${this.selectedHeaders}_n`]}})

      // Concatenamos a los maestros
      let arregloTeachers = tlu1.concat( tma1 ).concat( tmi1 ).concat( tju1 ).concat( tvi1 )
        
      // Quitamos los duplicados de los maestros
      this.teachers = Array.from(new Set(arregloTeachers.map(JSON.stringify))).map(JSON.parse);
    },

    sacarHorasSabado1 ( ) {

			// Recorremos los maestros para ir agregando las cosas
			for( const i in this.teachers ){

				// Sacamos el id del teacher
				const { id_teacher, teacher } = this.teachers[i]

				// Sacamos las clases donde esta el maestro 
				let clasesSabado = this.gruposActivos.filter( el => el[`lu${this.selectedHeaders}`] == id_teacher || el[`ma${this.selectedHeaders}`] == id_teacher || el[`mi${this.selectedHeaders}`] == id_teacher || el[`ju${this.selectedHeaders}`] == id_teacher || el[`vi${this.selectedHeaders}`] == id_teacher )
    	  let clasesDoblesSabatino = this.horasDoblesSabatino.filter( el => el.tipo == 2 )

				// Lo separamos por escuela
				const clasesFast      = clasesSabado.filter( el => { return el.id_unidad_negocio == 2})
				const clasesInbi      = clasesSabado.filter( el => { return el.id_unidad_negocio == 1})
				const clasesInbiTeens = clasesSabado.filter( el => { return el.id_unidad_negocio == 1})

				let clasesInbiContador = 0
				let clasesFastContador = 0

				let contadorBloquesFast = 0
				for( const i in clasesFast ){

					contadorBloquesFast += clasesFast[i][`lu${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`ma${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`mi${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`ju${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`vi${this.selectedHeaders}`] == id_teacher ? 1 : 0

					clasesFastContador += clasesFast[i][`lu${this.selectedHeaders}`] == id_teacher ? 1 : 0
				}

				let contadorBloquesInbi = 0
				for( const i in clasesInbi ){

					const { grupo } = clasesInbi[i]

					if( grupo.match('TEENS') ){

					}else{
						contadorBloquesInbi += clasesInbi[i][`lu${this.selectedHeaders}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`ma${this.selectedHeaders}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`mi${this.selectedHeaders}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`ju${this.selectedHeaders}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`vi${this.selectedHeaders}`] == id_teacher ? 1 : 0

						clasesInbiContador += clasesInbi[i][`lu${this.selectedHeaders}`] == id_teacher ? 1 : 0
					}
				}

				// CLASES TEENS
				let contadorBloqueTeens = 0
				let clasesTeens = clasesInbi.filter( el => { return el.grupo.match('TEENS') })

				for( const i in clasesTeens ){
					const { grupo } = clasesTeens[i]
					contadorBloqueTeens += clasesTeens[i][`lu${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloqueTeens += clasesTeens[i][`ma${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloqueTeens += clasesTeens[i][`mi${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloqueTeens += clasesTeens[i][`ju${this.selectedHeaders}`] == id_teacher ? 1 : 0
					contadorBloqueTeens += clasesTeens[i][`vi${this.selectedHeaders}`] == id_teacher ? 1 : 0
					// contadorBloqueTeens += 3
					clasesInbiContador  += 1
				}

				const existeCategoria = this.pagos.find( el => el.id_usuario  == id_teacher )

				let hora_1   = existeCategoria ? existeCategoria.hora_1   : 0
				let hora_2   = existeCategoria ? existeCategoria.hora_2   : 0
				let hora_3   = existeCategoria ? existeCategoria.hora_3   : 0
				let aceptado = existeCategoria ? existeCategoria.aceptado : 0
				let hsbc     = existeCategoria ? existeCategoria.hsbc     : 0

				// AGREGAREMOS LOS PAGOS
				this.teachers[i]['categoria']  = hora_2
				this.teachers[i]['aceptado']   = aceptado
				this.teachers[i]['hsbc']       = hsbc
				this.teachers[i]['existeCategoria'] = 1

				const total_horas = contadorBloquesFast + contadorBloquesInbi + contadorBloqueTeens

				let totalClases = this.gruposActivos.filter( el => el[`lu${this.selectedHeaders}`] == id_teacher || el[`ma${this.selectedHeaders}`] == id_teacher || el[`mi${this.selectedHeaders}`] == id_teacher || el[`ju${this.selectedHeaders}`] == id_teacher || el[`vi${this.selectedHeaders}`] == id_teacher ).length

				let clasesTeacher = this.gruposActivos.filter( el => el[`lu${this.selectedHeaders}`] == id_teacher || el[`ma${this.selectedHeaders}`] == id_teacher || el[`mi${this.selectedHeaders}`] == id_teacher || el[`ju${this.selectedHeaders}`] == id_teacher || el[`vi${this.selectedHeaders}`] == id_teacher )

				this.teachers[i]['CLASES_SABADO_FAST']  = clasesFast.length
				this.teachers[i]['HORAS_SABADO_FAST']   = contadorBloquesFast
				this.teachers[i]['CLASES_SABADO_INBI']  = clasesInbi.length
				this.teachers[i]['HORAS_SABADO_INBI']   = contadorBloquesInbi
				this.teachers[i]['CLASES_SABADO_TEENS'] = clasesTeens.length
				this.teachers[i]['HORAS_SABADO_TEENS']  = contadorBloqueTeens
				this.teachers[i]['TOTAL_CLASES']        = totalClases
				this.teachers[i]['TOTAL_HORAS']         = contadorBloquesFast + contadorBloquesInbi + contadorBloqueTeens

				/* SACAR LOS REABJES */


        // CLASES DOBLES
        const pagosDoblesTeachers = clasesDoblesSabatino.filter(el => [`lu${this.selectedHeaders}`, `ma${this.selectedHeaders}`, `mi${this.selectedHeaders}`, `ju${this.selectedHeaders}`, `vi${this.selectedHeaders}`].includes( el.bloque ) && el.id_teacher_reemplazo == id_teacher);
        const rebajesDobles = clasesDoblesSabatino.filter(el => [`lu${this.selectedHeaders}`, `ma${this.selectedHeaders}`, `mi${this.selectedHeaders}`, `ju${this.selectedHeaders}`, `vi${this.selectedHeaders}`].includes( el.bloque ) && el.id_teacher_falto == id_teacher);
        let pagoDoble = pagosDoblesTeachers.map(item => item.monto_pago).reduce((prev, curr) => prev + curr, 0)
        // let rebajeDoble = rebajesDobles.map(item => item.monto_rebaje).reduce((prev, curr) => prev + curr, 0)
        this.teachers[i]['PAGO_DOBLES_SABADO'] = pagoDoble
        // this.teachers[i]['REBAJES_SABADO']     = rebajeDoble

				this.teachers[i]['PAGO_SABADO']         = this.format( ( contadorBloquesInbi * hora_2 ) + ( contadorBloquesFast * hora_2 ) + ( contadorBloqueTeens * hora_2 ))
				this.teachers[i]['PAGO_SABADO_TOTAL']   = this.format( ( contadorBloquesInbi * hora_2 ) + ( contadorBloquesFast * hora_2 ) + ( contadorBloqueTeens * hora_2 ) + pagoDoble )
        
        this.teachers[i]['plantel']             = clasesSabado.length ? clasesSabado[0].plantel : 'SIN PLANTEL'
				this.teachers[i]['id_plantel']          = clasesSabado.length ? clasesSabado[0].id_plantel : 0

				// Aquí... poner esa cosa de los comentarios
				const existeEstatusS = this.comentariosT.find( el => el.id_usuario == id_teacher && el.semana == this.selectedHeaders && el.tipo_nomina == 1 )

				this.teachers[i]['estatus_sabatina']     = existeEstatusS ? existeEstatusS.estatus : 0 
				this.teachers[i]['comentarios_sabatina'] = existeEstatusS ? existeEstatusS.comentarios : [] 

			}
    },

    sacarTotales ( ){

    	// Agregar los rebajes

    	// this.teachers.push({
    	// 	id_teacher: 100000,
      //   teacher   : 'TOTAL',
      //   HORAS_SABADO_FAST  : this.teachers.map(item => item.HORAS_SABADO_FAST).reduce((prev, curr) => prev + curr, 0),
      //   HORAS_SABADO_INBI  : this.teachers.map(item => item.HORAS_SABADO_INBI).reduce((prev, curr) => prev + curr, 0),
      //   HORAS_SABADO_TEENS : this.teachers.map(item => item.HORAS_SABADO_TEENS).reduce((prev, curr) => prev + curr, 0),
      //   // bono_teacher       : this.teachers.map(item => item.bono_teacher).reduce((prev, curr) => prev + curr, 0),
      //   TOTAL_HORAS        : this.teachers.map(item => item.TOTAL_HORAS ).reduce((prev, curr) => prev + curr, 0),
      //   PAGO_SABADO        : this.teachers.map(item => item.PAGO_SABADO).reduce((prev, curr) => prev + curr, 0),
    	// })
    },

    formatMoney ( ) {
    	// En teoría aquí ya está todo
    	try{
	    	for( const i in this.teachers ){

	    		const { HORAS_SABADO_FAST, HORAS_SABADO_INBI, HORAS_SABADO_TEENS, TOTAL_HORAS, PAGO_SABADO, id_teacher } = this.teachers[i]

	    		// this.teachers[i].PAGO_SABADO  = PAGO_SABADO ? this.format( PAGO_SABADO ) : '$0.00' 
	    		this.teachers[i]['categoria'] = this.teachers[i]['categoria'] ? this.format( this.teachers[i]['categoria'] ) : '$0.00' 

	    	}

    	}catch( error ){
    		this.validarErrorDirecto( error.message )
    	}

    },

		toNumber ( v ){
			return parseFloat(String(v || '$0').replace('$','').replace(',','')) || 0
		},

    getTablaComparativa( ){

    	// Mi variable de la tabla 1 comparativa = tabla1Comparativa

    	// Primero, sacar la semana anterior
    	let getCategorias = this.teachers.filter( el => el.id_teacher < 100000 ).map((registro) => { return registro.categoria })

    	this.categorias1 = [...new Set(getCategorias)].sort((a, b) => b - a) 

    	for( const i in this.categorias1 ){

    		let teachersCategoria = this.teachers.filter( el => el.categoria == this.categorias1[i] && el.id_teacher < 100000 )

    		let totalHoras =  teachersCategoria.map(item => item.TOTAL_HORAS ).reduce((prev, curr) => prev + curr, 0)


    		this.tabla1Comparativa.push({
    			valor_hora   : this.categorias1[i] == null ? 'TEACHER LIDER' : this.categorias1[i] ,
    			numero_horas : totalHoras,
    			costo        : this.format( totalHoras * this.categorias1[i] )
    		})

    	}

    	this.tabla1Comparativa.push({
  			valor_hora   : 'Horas totales',
  			numero_horas : this.teachers.filter( el => el.teacher != 'TOTAL' ).map(item => item.TOTAL_HORAS ).reduce((prev, curr) => prev + curr, 0),
  			costo        : this.format( this.teachers.filter( el => el.teacher != 'TOTAL' ).map(item => parseFloat( item.PAGO_SABADO_TOTAL.replace('$','').replace(',','') ) ).reduce((prev, curr) => prev + curr, 0))
  		})

			console.log( this.teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => parseFloat(  item.PAGO_SABADO_TOTAL.replace('$','').replace(',','') ) ).reduce((prev, curr) => prev + curr, 0))

			// costoTotal para costoHora2
			let costoTotal2 = this.teachers
				.filter(el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER')
				.map(item => this.toNumber(item.PAGO_SABADO) + this.toNumber(item.PAGO_DOBLES_SABADO))
				.reduce((prev, curr) => prev + curr, 0)

				let costoTotal3 = this.teachers
				.filter(el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER')
				.map(item => this.toNumber(item.PAGO_DOBLES_SABADO))
				.reduce((prev, curr) => prev + curr, 0)
			
			console.log( costoTotal2 + costoTotal3 )

  		this.tabla1Comparativa.push({
  			valor_hora   : 'Horas impartidas',
  			numero_horas : this.teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.TOTAL_HORAS).reduce((prev, curr) => prev + curr, 0),
  			costo        : this.format( costoTotal2 + costoTotal3 )
  		})

			// ... dentro de getTablaComparativa()
			

			// // Horas totales
			// costo: this.format(
			// 	this.teachers
			// 		.filter(el => el.teacher != 'TOTAL')
			// 		.map(item => toNumber(item.PAGO_SABADO) + toNumber(item.PAGO_DOBLES_SABADO))
			// 		.reduce((prev, curr) => prev + curr, 0)
			// )

			// // Horas impartidas
			// costo: this.format(
			// 	this.teachers
			// 		.filter(el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER')
			// 		.map(item => toNumber(item.PAGO_SABADO) + toNumber(item.PAGO_DOBLES_SABADO))
			// 		.reduce((prev, curr) => prev + curr, 0)
			// )

			// // costoTotal para costoHora2
			// let costoTotal = this.teachers
			// 	.filter(el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER')
			// 	.map(item => toNumber(item.PAGO_SABADO) + toNumber(item.PAGO_DOBLES_SABADO))
			// 	.reduce((prev, curr) => prev + curr, 0)


  		// this.tabla1Comparativa.push({
  		// 	valor_hora   : 'Horas totales',
  		// 	numero_horas : this.gruposActivos.filter( el => { return el.deleted == 0 && el.sabado }).map(item => item.horas_semana ).reduce((prev, curr) => prev + curr, 0),
  		// 	costo        : this.format( this.teachers.filter( el => el.teacher != 'TOTAL' ).map(item => item.PAGO_SABADO).reduce((prev, curr) => prev + curr, 0))
  		// })

  		// this.tabla1Comparativa.push({
  		// 	valor_hora   : 'Horas impartidas',
  		// 	numero_horas : this.teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.TOTAL_HORAS).reduce((prev, curr) => prev + curr, 0),
  		// 	costo        : this.format( teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.PAGO_SABADO).reduce((prev, curr) => prev + curr, 0))
  		// })

  		this.horasImpartidas = this.teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.TOTAL_HORAS).reduce((prev, curr) => prev + curr, 0)
  		let costoTotal       = this.teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => parseFloat( item.PAGO_SABADO.replace('$','').replace(',','') ) ).reduce((prev, curr) => prev + curr, 0)


  		this.costoHora2     = this.format( costoTotal / this.horasImpartidas )
    },

    getTablaComparativaAnt( ){

    	let semana = this.selectedHeaders == 1 ? 4 : this.selectedHeaders - 1 

    	let gruposActivos = this.selectedHeaders == 1 ? this.gruposRoles2 : this.gruposActivos

    	for( const i in gruposActivos ){

    		const { lunes, martes, miercoles, jueves, viernes, sabado, domingo } = gruposActivos[i]

    		if( sabado || domingo ){
    			gruposActivos[i][`lu${semana}_n`] = gruposActivos[i][`lu${semana}_n`] == '' ? 0 : gruposActivos[i][`lu${semana}_n`]
    			gruposActivos[i][`ma${semana}_n`] = gruposActivos[i][`ma${semana}_n`] == '' ? 0 : gruposActivos[i][`ma${semana}_n`]
    			gruposActivos[i][`mi${semana}_n`] = gruposActivos[i][`mi${semana}_n`] == '' ? 0 : gruposActivos[i][`mi${semana}_n`]
    			gruposActivos[i][`ju${semana}_n`] = gruposActivos[i][`ju${semana}_n`] == '' ? 0 : gruposActivos[i][`ju${semana}_n`]
    			gruposActivos[i][`vi${semana}_n`] = gruposActivos[i][`vi${semana}_n`] == '' ? 0 : gruposActivos[i][`vi${semana}_n`]
    		}
    	}

    	// Sacar a los teachers que dan clase
    	// Vamos a sacar los teachers de cada bloque
      let tlu1 = gruposActivos.filter( el => { return el[`lu${semana}_n`] }).map((registro) => { return { id_teacher: registro[`lu${semana}`], teacher: registro[`lu${semana}_n`]}})
      let tma1 = gruposActivos.filter( el => { return el[`ma${semana}_n`] }).map((registro) => { return { id_teacher: registro[`ma${semana}`], teacher: registro[`ma${semana}_n`]}})
      let tmi1 = gruposActivos.filter( el => { return el[`mi${semana}_n`] }).map((registro) => { return { id_teacher: registro[`mi${semana}`], teacher: registro[`mi${semana}_n`]}})
      let tju1 = gruposActivos.filter( el => { return el[`ju${semana}_n`] }).map((registro) => { return { id_teacher: registro[`ju${semana}`], teacher: registro[`ju${semana}_n`]}})
      let tvi1 = gruposActivos.filter( el => { return el[`vi${semana}_n`] }).map((registro) => { return { id_teacher: registro[`vi${semana}`], teacher: registro[`vi${semana}_n`]}})

      // Concatenamos a los maestros
      let arregloTeachers = tlu1.concat( tma1 ).concat( tmi1 ).concat( tju1 ).concat( tvi1 )
        
      // Quitamos los duplicados de los maestros
      let teachers = Array.from(new Set(arregloTeachers.map(JSON.stringify))).map(JSON.parse);

      // Recorremos los maestros para ir agregando las cosas
			for( const i in teachers ){

				// Sacamos el id del teacher
				const { id_teacher } = teachers[i]

				// Sacamos las clases donde esta el maestro 
				let clasesSabado = gruposActivos.filter( el => el[`lu${semana}`] == id_teacher || el[`ma${semana}`] == id_teacher || el[`mi${semana}`] == id_teacher || el[`ju${semana}`] == id_teacher || el[`vi${semana}`] == id_teacher )

				// Lo separamos por escuela
				const clasesFast      = clasesSabado.filter( el => { return el.id_unidad_negocio == 2})
				const clasesInbi      = clasesSabado.filter( el => { return el.id_unidad_negocio == 1})
				const clasesInbiTeens = clasesSabado.filter( el => { return el.id_unidad_negocio == 1})

				let clasesInbiContador = 0
				let clasesFastContador = 0

				let contadorBloquesFast = 0
				for( const i in clasesFast ){

					contadorBloquesFast += clasesFast[i][`lu${semana}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`ma${semana}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`mi${semana}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`ju${semana}`] == id_teacher ? 1 : 0
					contadorBloquesFast += clasesFast[i][`vi${semana}`] == id_teacher ? 1 : 0

					clasesFastContador += clasesFast[i][`lu${semana}`] == id_teacher ? 1 : 0
				}

				let contadorBloquesInbi = 0
				for( const i in clasesInbi ){

					const { grupo } = clasesInbi[i]

					if( grupo.match('TEENS') ){

					}else{
						contadorBloquesInbi += clasesInbi[i][`lu${semana}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`ma${semana}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`mi${semana}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`ju${semana}`] == id_teacher ? 1 : 0
						contadorBloquesInbi += clasesInbi[i][`vi${semana}`] == id_teacher ? 1 : 0

						clasesInbiContador += clasesInbi[i][`lu${semana}`] == id_teacher ? 1 : 0
					}
				}

				// CLASES TEENS
				let contadorBloqueTeens = 0
				let clasesTeens = clasesInbi.filter( el => { return el.grupo.match('TEENS') })

				for( const i in clasesTeens ){
					const { grupo } = clasesTeens[i]
					contadorBloqueTeens += 3
					clasesInbiContador  += 1
				}

				const existeCategoria = this.pagos.find( el => el.id_usuario  == id_teacher )

				let hora_1 = existeCategoria ? existeCategoria.hora_1 : 0
				let hora_2 = existeCategoria ? existeCategoria.hora_2 : 0
				let hora_3 = existeCategoria ? existeCategoria.hora_3 : 0

				// AGREGAREMOS LOS PAGOS
				teachers[i]['categoria']  = hora_2

				const total_horas = contadorBloquesFast + contadorBloquesInbi + contadorBloqueTeens

				let totalClases = this.gruposActivos.filter( el => el[`lu${this.selectedHeaders}`] == id_teacher || el[`ma${this.selectedHeaders}`] == id_teacher || el[`mi${this.selectedHeaders}`] == id_teacher || el[`ju${this.selectedHeaders}`] == id_teacher || el[`vi${this.selectedHeaders}`] == id_teacher ).length

				teachers[i]['CLASES_SABADO_FAST']  = clasesFast.length
				teachers[i]['HORAS_SABADO_FAST']   = contadorBloquesFast
				teachers[i]['CLASES_SABADO_INBI']  = clasesInbi.length
				teachers[i]['HORAS_SABADO_INBI']   = contadorBloquesInbi
				teachers[i]['CLASES_SABADO_TEENS'] = clasesTeens.length
				teachers[i]['HORAS_SABADO_TEENS']  = contadorBloqueTeens
				teachers[i]['TOTAL_CLASES']        = totalClases
				teachers[i]['TOTAL_HORAS']         = contadorBloquesFast + contadorBloquesInbi + contadorBloqueTeens

				teachers[i]['PAGO_SABADO']         = ( contadorBloquesInbi * hora_2 ) + ( contadorBloquesFast * hora_2 ) + ( contadorBloqueTeens * hora_2 )

			}


    	// Mi variable de la tabla 1 comparativa = tabla1Comparativa

    	// Primero, sacar la semana anterior
    	let getCategorias = teachers.filter( el => el.id_teacher < 100000 ).map((registro) => { return registro.categoria })

    	this.categorias2 = [...new Set(getCategorias)].sort((a, b) => b - a) 

    	for( const i in this.categorias2 ){

    		let teachersCategoria = teachers.filter( el => el.categoria == this.categorias2[i] && el.id_teacher < 100000 )

    		let totalHoras =  teachersCategoria.map(item => item.TOTAL_HORAS ).reduce((prev, curr) => prev + curr, 0)

    		let categoria = this.categorias2[i] == null ? 'TEACHER LIDER' : this.categorias2[i] 

    		if( categoria == 70 ){
    			totalHoras = totalHoras - 3
    		}

    		if( categoria == 65 ){
    			totalHoras = totalHoras 
    		}

    		this.tabla2Comparativa.push({
    			valor_hora   : this.categorias2[i] == null ? 'TEACHER LIDER' : this.categorias2[i] ,
    			numero_horas : totalHoras,
    			costo        : this.format( totalHoras * this.categorias2[i] )
    		})

    	}

    	let numero_horas = teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.TOTAL_HORAS).reduce((prev, curr) => prev + curr, 0)
    	let costoG = teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.PAGO_SABADO).reduce((prev, curr) => prev + curr, 0) 

    	this.tabla2Comparativa.push({
  			valor_hora   : 'Horas totales',
  			numero_horas : teachers.filter( el => el.teacher != 'TOTAL' ).map(item => item.TOTAL_HORAS).reduce((prev, curr) => prev + curr, 0),
  			costo        : this.format( teachers.filter( el => el.teacher != 'TOTAL' ).map(item => item.PAGO_SABADO).reduce((prev, curr) => prev + curr, 0))
  		})

  		this.tabla2Comparativa.push({
  			valor_hora   : 'Horas impartidas',
  			numero_horas : numero_horas,
  			costo        : this.format( costoG )
  		})

  		this.horasImpartidasAnt = teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.TOTAL_HORAS).reduce((prev, curr) => prev + curr, 0)
  		let costoTotal          = teachers.filter( el => el.teacher != 'TOTAL' && el.teacher != 'SIN TEACHER').map(item => item.PAGO_SABADO).reduce((prev, curr) => prev + curr, 0)

  		this.costoHora1     = this.format( costoTotal / this.horasImpartidasAnt )
    },

    igualarCategorias( ){

    	if( this.tabla1Comparativa.length != this.tabla2Comparativa.length ){


    		if( this.tabla1Comparativa.length > this.tabla2Comparativa.length ){

					const findIndexById = (arr, valor_hora) => arr.findIndex(obj => obj.valor_hora == valor_hora);
    			this.tabla1Comparativa.forEach((obj, index) => {
					  const foundIndex = findIndexById(this.tabla2Comparativa, obj.valor_hora);
					  if (foundIndex === -1) {
					    // Insertar el objeto en la misma posición que en array1
					    let objeto = {
					    	valor_hora: obj.valor_hora,
					    	numero_horas: 0,
					    	costo: '$0.00'
					    }
					    this.tabla2Comparativa.splice(index, 0, objeto);
					  }
					});

    		}else{

    			// Función para encontrar el índice de un objeto por id
					const findIndexById = (arr, valor_hora) => arr.findIndex(obj => obj.valor_hora == valor_hora);


					this.tabla2Comparativa.forEach((obj, index) => {
					  const foundIndex = findIndexById(this.tabla1Comparativa, obj.valor_hora);
					  if (foundIndex === -1) {
					    // Insertar el objeto en la misma posición que en array1
					    let objeto = {
					    	valor_hora: obj.valor_hora,
					    	numero_horas: 0,
					    	costo: '$0.00'
					    }
					    this.tabla1Comparativa.splice(index, 0, objeto);
					  }
					});


    			// for( const i in this.tabla2Comparativa ){

    				// if( !this.tabla1Comparativa.find( el => el.valor_hora == this.tabla2Comparativa[i].valor_hora ) ){

    				// 	// this.tabla2Comparativa.push({

    				// 	// })

    				// 	alert(`no encontre la categoria 2: ${ this.tabla2Comparativa[i].valor_hora }`)

    				// }

    			// }

    		}

    	}
    },

    motivoDiferencias ( ) {

    	for( const i in this.tabla2Comparativa ){

    		const { numero_horas, valor_hora, costo } = this.tabla2Comparativa[i]

    		let diferencia = this.tabla1Comparativa[i].numero_horas - numero_horas

    		let diferenciaM = parseFloat( this.tabla1Comparativa[i].costo.replace('$','').replace(',','')) - parseFloat( costo.replace('$','').replace(',','') )

    		this.tabla1Comparativa[i]['diferencia']  = this.format( diferenciaM )

    		if( numero_horas > this.tabla1Comparativa[i].numero_horas ){
    			
    			this.tabla1Comparativa[i]['motivo'] = `Menos ${ diferencia } horas de ${ valor_hora }`

    		}else if( numero_horas == this.tabla1Comparativa[i].numero_horas ){
    			
    			this.tabla1Comparativa[i]['motivo'] = 'No hay diferencia'

    		}else{

    			this.tabla1Comparativa[i]['motivo'] = `Más ${ diferencia } horas de ${ valor_hora }`

    		}
    		// 

    	}
			// this.tabla2Comparativa
    },

    bloquear( value ) { 

    	if( [1,3].includes( this.selectedHeaders ) ){

    		this.bloquearQuincena( value )

    	}

    	this.bloquearSabatino( value )

    },

    buildPayloadRequisicionTeachers( ) {
      // Toda la nómina (sin filtro de tabla) + teachers que solo traen bono.
      const base = buildTeachersConDetalle(this.teachers);
      const ids = {};
      base.forEach((t) => { ids[Number(t.id_teacher)] = true; });

      const extras = [];
      (this.bonosTeachers || []).forEach((b) => {
        const id = Number(b.id_usuario || b.id_teacher);
        const monto = Number(b.monto) || 0;
        if (!id || monto <= 0 || ids[id]) return;

        const formatBono = this.format ? this.format(monto) : ('$' + monto.toFixed(2));
        extras.push({
          id_teacher: id,
          teacher: b.nombre_completo || b.teacher || ('Teacher ' + id),
          PAGO_SABADO: '$0.00',
          pago_quincena: '$0.00',
          PAGO_DOBLE: '$0.00',
          REBAJES: '$0.00',
          bono_teacher: formatBono,
          plantel: b.plantel || '',
          id_plantel: b.id_plantel || 13,
          detalle_snapshot: {
            id_teacher: id,
            teacher: b.nombre_completo || b.teacher || '',
            bono_teacher: formatBono,
            PAGO_SABADO: '$0.00',
            pago_quincena: '$0.00',
          },
        });
        ids[id] = true;
      });

      return {
        teachers: base.concat(extras),
        id_usuario: this.getdatosUsuarioERPERP.iderp,
        id_ciclo: this.ciclo.id_ciclo,
        semana: this.selectedHeaders,
        comparativas: buildComparativasPayload(this),
        rol_snapshot: buildRolSnapshotSabatino(this.ciclo, this.selectedHeaders, this.gruposActivos),
      };
    },

    /**
     * Comparativa sabatina: semana anterior desde historial guardado (si existe);
     * semana actual siempre queda del cálculo en vivo (getTablaComparativa).
     */
    async aplicarHistorialSabAnterior( ) {
      if (!this.ciclo || !this.ciclo.id_ciclo) return;

      const anterior = getContextoSemanaAnterior(this.ciclo, this.selectedHeaders, this.cicloAnt);
      const actual = { id_ciclo: this.ciclo.id_ciclo, semana: this.selectedHeaders };

      let histAnterior = null;
      let histActual = null;

      try {
        const [resAnt, resAct] = await Promise.all([
          this.$http.post('get.historial.nomina.teacher', anterior),
          this.$http.post('get.historial.nomina.teacher', actual),
        ]);
        histAnterior = resAnt.data;
        histActual = resAct.data;
      } catch (e) {
        console.log('Historial comparativa sabatina no disponible', e);
        this.usandoHistorialSab = false;
        this.sinHistorialComparativaSab = !(this.tabla2Comparativa && this.tabla2Comparativa.length);
        return;
      }

      const findComp = (hist, tipo) => {
        const comparativas = hist && hist.comparativas ? hist.comparativas : [];
        return comparativas.find((c) => Number(c.tipo) === tipo);
      };

      const sabPrev = findComp(histAnterior, 1);
      const sabAct = findComp(histActual, 1);

      const tablaAnteriorHist = (sabPrev && sabPrev.tabla_actual)
        ? sabPrev.tabla_actual
        : ((sabAct && sabAct.tabla_anterior) ? sabAct.tabla_anterior : null);

      const snapAnt = histAnterior && Array.isArray(histAnterior.rol_snapshot)
        ? histAnterior.rol_snapshot
        : []
      this.gruposSnapshotSabAnterior = snapAnt

      if (tablaAnteriorHist) {
        this.tabla2Comparativa = tablaAnteriorHist;
        const costoHist = (sabPrev && sabPrev.costo_hora_actual)
          ? sabPrev.costo_hora_actual
          : ((sabAct && sabAct.costo_hora_anterior) ? sabAct.costo_hora_anterior : this.costoHora1);
        this.costoHora1 = costoHist;
        this.usandoHistorialSab = true;
        this.sinHistorialComparativaSab = false;

        // Alinear horasImpartidasAnt con la fila del historial (para costos / notas)
        const filaImp = (tablaAnteriorHist || []).find((r) =>
          r && String(r.valor_hora).toLowerCase().includes('impartida')
        );
        if (filaImp && filaImp.numero_horas != null) {
          this.horasImpartidasAnt = Number(filaImp.numero_horas) || this.horasImpartidasAnt;
        }
      } else {
        this.usandoHistorialSab = false;
        this.sinHistorialComparativaSab = !(this.tabla2Comparativa && this.tabla2Comparativa.length);
      }

      // Notas guardadas al generar la requisición de la semana actual
      if (sabAct && sabAct.notas) {
        this.notasSabatinoHistorial = sabAct.notas;
      } else {
        this.notasSabatinoHistorial = '';
      }

      if (this.selectedHeaders === 1) {
        const comparativasAnt = histAnterior && histAnterior.comparativas ? histAnterior.comparativas : [];
        const bonosPrev = comparativasAnt.find((c) => Number(c.tipo) === 3);
        if (bonosPrev && bonosPrev.tabla_bonos) {
          this.bonosAnterioresHistorial = bonosPrev.tabla_bonos;
        }

        // Bonos de la semana actual desde historial (API reconstruye el total máximo / requi)
        const comparativasAct = histActual && histActual.comparativas ? histActual.comparativas : [];
        const bonosAct = comparativasAct.find((c) => Number(c.tipo) === 3);
        if (bonosAct && Array.isArray(bonosAct.tabla_bonos) && bonosAct.tabla_bonos.length) {
          this.bonosHistorialActual = bonosAct.tabla_bonos;
        } else {
          this.bonosHistorialActual = [];
        }
      }
    },

    pagar( ){
			this.cargar = true

			var baseRequi = {
    		registro:                      null,
    		id_usuario_solicita:           this.getdatosUsuarioERPERP.iderp,
	      id_sucursal_solicita:          this.getdatosUsuarioERPERP.id_plantel,
	      id_requisicion_compra_estatus: 1,
	      id_usuario_ultimo_cambio:      this.getdatosUsuarioERPERP.iderp,
	      id_usuario_compra:             28,
	      tipo_requisicion:              1,
	      ciclo:                         this.ciclo,
        id_proyecto:                   null,
	      comentarios:                   'Nómina Teachers',
		    fotos:[]
      }


			const payload = {
				...this.buildPayloadRequisicionTeachers(),
				baseRequi,
			}

			this.$http.post('add.requi.teachers', payload).then(response=>{
				this.validarSuccess('Datos grabados correctamente')
				this.cargar       = false
				this.dialogPagar  = false
				this.initialize()
			}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { this.cargar = false })	

    },


    crearRequi( ){
    	this.cargar = true

			var baseRequi = {
    		registro:                      null,
    		id_usuario_solicita:           this.getdatosUsuarioERPERP.iderp,
	      id_sucursal_solicita:          this.getdatosUsuarioERPERP.id_plantel,
	      id_requisicion_compra_estatus: 1,
	      id_usuario_ultimo_cambio:      this.getdatosUsuarioERPERP.iderp,
	      id_usuario_compra:             28,
	      tipo_requisicion:              1,
	      ciclo:                         this.ciclo,
        id_proyecto:                   null,
	      comentarios:                   'Nómina Teachers',
		    fotos:[]
      }


			const payload = {
				...this.buildPayloadRequisicionTeachers(),
				baseRequi,
			}

			this.$http.post('add.requi.teachers.fake', payload).then(response=>{
				
				this.requisTeacherInbiS = response.data.detallesSabatinaInbi
				this.requisTeacherInbiQ = response.data.detallesQuincenaInbi
				this.requisTeacherFastS = response.data.detallesSabatinaFast
				this.requisTeacherFastQ = response.data.detallesQuincenaFast
				this.detallesBonoInbi   = response.data.detallesBonoInbi
				this.detallesBonoFast   = response.data.detallesBonoFast

				this.cargar       = false
				this.dialogRequis = true
				this.initialize()
			}).catch( error =>{
				this.validarError( error.response.data.message )
			}).finally( () => { this.cargar = false })	
    },

    bloquearSabatino( liberada ){
    	const payload = {
    		id_ciclo: this.ciclo.id_ciclo,
    		semana  : this.selectedHeaders,
    		tipo    : 1,
    		liberada
    	}

    	this.cargar      = true
      this.$http.post('rol.clases.bloquear', payload ).then(response=>{
      	if( liberada == 1 ){
        	this.validarSuccess('Liberación de nómina correctamente')
      	}else{
        	this.validarSuccess('Bloqueo de nómina correctamente')
      	}
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    bloquearQuincena( liberada ){

    	const payload = {
    		id_ciclo : this.ciclo.id_ciclo,
    		semana   : this.selectedHeaders == 1 ? [3,4] : [ 1, 2 ],
    		cicloAnt : this.selectedHeaders == 1 ? this.cicloAnt : this.ciclo.id_ciclo,
    		tipo     : 2,
    		liberada
    	}

    	this.cargar      = true
      this.$http.post('rol.clases.bloquear.quincena', payload ).then(response=>{
        if( liberada == 1 ){
        	this.validarSuccess('Liberación de nómina correctamente')
      	}else{
        	this.validarSuccess('Bloqueo de nómina correctamente')
      	}
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    format( valor ){
		  return valor.toLocaleString('es-MX', {
		    style: 'currency',
		    currency: 'MXN'
		  });
    }

  }
}